import './Descripcion.css'

const Descripcion = ({ d1, d2 }) => {
    return (
        <p>
            {d1}<br/>{d2}
        </p>
    )
}

export default Descripcion;
